export default "__VITE_ASSET__Da7gQXDi__"